import type { FaireProductEntity } from "../../entity_types/product";

export const p_ykeaawv8zu: FaireProductEntity = {
  token: "p_ykeaawv8zu",
  type: "product",
  name: "Strawberry & Salty Peanut Granola",
  brandToken: "b_6pds9k9e3d",
  brandName: "Sweet Deliverance",
  imageUrl: "https://cdn.faire.com/fastly/ef4aa20f28446a22059fbacebeaa4d5f8f749263097b686506abfbdcd7642d4b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/727c8cd5a48eb1a24d2584340735579e4b14ec14714cfd627832edd211eb0d69.png",
    "https://cdn.faire.com/fastly/49b09b136d5d2aa3c1d82bfd8586f5ec6b624e1e504967e4527e5650068925e6.png",
    "https://cdn.faire.com/fastly/1baca1c90cf0330536387db46cd60b73955f0e18f68e1b003c760b4aa7f3b703.jpeg"
  ],
  priceDollars: 8.25,
  description: "Nothing beats a poolside lunch of peanut butter and jelly with potato chips, except this salty-sweet granola. The perfect gluten-free blend of protein-packed peanuts with organic, nutrient-dense chia, hemp, pumpkin, and flax seeds, plus beautiful slices of crispy, freeze-dried strawberries for a touch of sweetness. Let the nostalgia wash over you with every bite.\n\nThis granola is a 2024 Good Food Awards Finalist!",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:22.274Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
